/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";

// Dashboard example components

import DataTable from "examples/Tables/DataTable";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

// DatePicker components and  styling

import { addMinutes, format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";

import { CSVLink } from "react-csv";

// Utils component
import TextError from "utils/TextError";

// Notification
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Functions from store
import {
  createDynamicColumn,
  getDynamicColumn,
  getMonthlyDemand,
  getMonthlyDemandDownload,
  getPartNo,
  getPartNoForPlanner,
  getPlant,
  getSubModulesByRoleId,
  getVendorsListForPlanner,
  updateCNFQty,
  updateCnfQtyStatusByPlanner,
  updateRemark,
  uploadCsvForMonthlyDemand,
} from "../../../store";

// React-Select component and styling
import Select from "react-select";
import Config from "../../../config/index";
import "../../../index.css";

// Cookies
import DownloadButton from "components/standardized-components/DownloadButton";
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import UploadButton from "components/standardized-components/UploadButton";
import Cookies from "universal-cookie";

const cookies = new Cookies();

let desLength = Config.descriptionLength;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  color: "black",

  boxShadow: 24,
  p: 2,
  pt: 3,
};

const enableStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const styleForColumnReorder = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const MonthlyDemand = ({
  getMonthlyDemand,
  monthlyDemandReducer,
  getPartNoForPlanner,
  partNoForPlannerReducer,
  monthlyDemandDownloadReducer,
  getPartNo,
  partNoReducer,
  getPlant,
  getVendorsListForPlanner,
  vendorsListForPlannerReducer,
  plantReducer,
  updateCNFQty,
  updateRemark,
  getMonthlyDemandDownload,
  uploadCsvForMonthlyDemand,
  updateCnfQtyStatusByPlanner,
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
    getDynamicColumn,
  createDynamicColumn,
  getDynamicColumnReducer
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let userId = loginDetails?.data.userId;
  let roleName = loginDetails.data.roleName;
  let roleId = loginDetails.data.roleId;
  let email = loginDetails.data.email;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : []
    );
  }, [getSubModulesByRoleIdReducer]);

  
let dynamicColumnDetails = cookies.get("dynamic-column-data");
  
  const subModuleId = "52a93c0b-3763-447f-a3e4-870c452ecce7";

  let monthlyDemandModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "52a93c0b-3763-447f-a3e4-870c452ecce7"
  );

  let createAccess = monthlyDemandModule
    ? monthlyDemandModule.actionId.includes(
        "a3a93ab6-7b99-4788-b89c-9b4d024e0f75"
      )
    : null;

  let uploadAccess = monthlyDemandModule
    ? monthlyDemandModule.actionId.includes(
        "73b1e9fb-4894-4b07-98e2-b2a043070adf"
      )
    : null;

  let viewAccess = monthlyDemandModule
    ? monthlyDemandModule.actionId.includes(
        "41de7c82-6ba5-48fe-b635-22be183f8ddf"
      )
    : null;

  let updateCnfQtyAccess = monthlyDemandModule
    ? monthlyDemandModule.actionId.includes(
        "eb67cfb5-90a1-4306-840e-889e3cf067f2"
      )
    : null;

  let enableUpdateCnfQtyAccess = monthlyDemandModule
    ? monthlyDemandModule.actionId.includes(
        "f04db43b-9f1c-4fc5-b603-ffb41c6a3811"
      )
    : null;

  let downloadAccess = monthlyDemandModule
    ? monthlyDemandModule.actionId.includes(
        "13f985c6-8603-48aa-912a-c955fab80a2f"
      )
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };

  const [uploadLoader, setUploadLoader] = useState(false);

  const [vendorsListForPlannerSelected, setVendorsListForPlannerSelected] =
    useState("");
  const [partNoSelected, setPartNoSelected] = useState("");
  const [plantSelected, setPlantSelected] = useState("");

  useEffect(() => {
    getVendorsListForPlanner(jwtToken);
  }, []);

  useEffect(() => {
    let timeout = setTimeout(() => {
      getMonthlyDemand(
        email,
        partNoSelected ? partNoSelected.value : "",
        plantSelected ? plantSelected.value : "",
        vendorsListForPlannerSelected
          ? vendorsListForPlannerSelected.value
          : "",
        roleName,
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken
      );
    }, 200);

    return () => clearTimeout(timeout);
  }, [
    pageNo,
    rowsPerPage,
    searchObject,
    email,
    partNoSelected,
    plantSelected,
    vendorsListForPlannerSelected,
  ]);

  useEffect(() => {
    let timeout = setTimeout(() => {
      getMonthlyDemandDownload(
        email,
        partNoSelected ? partNoSelected.value : "",
        plantSelected ? plantSelected.value : "",
        vendorsListForPlannerSelected
          ? vendorsListForPlannerSelected.value
          : "",
        roleName,
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken
      );
    }, 200);

    return () => clearTimeout(timeout);
  }, [
    pageNo,
    rowsPerPage,
    searchObject,
    email,
    partNoSelected,
    plantSelected,
    vendorsListForPlannerSelected,
  ]);

  useEffect(() => {
    roleName !== "vendor" && getPartNoForPlanner(jwtToken);
  }, []);

  useEffect(() => {
    // roleName == "Vendor" &&
    getPartNo(
      vendorsListForPlannerSelected
        ? vendorsListForPlannerSelected.email
        : email,
      jwtToken
    );
  }, [userId, vendorsListForPlannerSelected]);

  useEffect(() => {
    getPlant(jwtToken);
  }, []);

  const handleChangeVendorsListForPlanner = (selectedOption) => {
    setVendorsListForPlannerSelected(selectedOption);
    setPartNoSelected("");
  };

  const [vendorsListForPlannerOptions, setVendorsListForPlannerOptions] =
    useState([]);

  useEffect(() => {
    let tempVendorsListForPlannerOptions = [];
    let data = vendorsListForPlannerReducer.vendorsListForPlannerData.data
      ? vendorsListForPlannerReducer.vendorsListForPlannerData.data
      : [];

    data.map((vendorsListForPlanner) => {
      tempVendorsListForPlannerOptions.push({
        label: vendorsListForPlanner.vendorName,
        value: vendorsListForPlanner.vendorCode,
        vendorId: vendorsListForPlanner.vendorUserId,
      });
    });
    setVendorsListForPlannerOptions(tempVendorsListForPlannerOptions);
  }, [vendorsListForPlannerReducer]);

  const handleChangePartNoForPlanner = (selectedOption) => {
    setPartNoSelected(selectedOption);
  };

  const [partNoForPlannerOptions, setPartNoForPlannerOptions] = useState([]);

  useEffect(() => {
    let tempPartNoForPlannerOptions = [];
    let data = partNoForPlannerReducer.partNoForPlannerData.data
      ? partNoForPlannerReducer.partNoForPlannerData.data
      : [];
    data.map((partNo) => {
      tempPartNoForPlannerOptions.push({
        label: partNo.itemCode,
        value: partNo.itemCode,
      });
    });
    setPartNoForPlannerOptions(tempPartNoForPlannerOptions);
  }, [partNoForPlannerReducer]);

  const handleChangePartNo = (selectedOption) => {
    setPartNoSelected(selectedOption);
  };

  const [partNoOptions, setPartNoOptions] = useState([]);

  useEffect(() => {
    let tempPartNoOptions = [];
    let data = partNoReducer.partNoData.data
      ? partNoReducer.partNoData.data
      : [];
    data.map((partNo) => {
      tempPartNoOptions.push({
        label: partNo.itemCode,
        value: partNo.itemCode,
      });
    });
    setPartNoOptions(tempPartNoOptions);
  }, [partNoReducer]);

  useEffect(() => {
    if (partNoOptions && roleName == "vendor") {
      setPartNoSelected({
        label: partNoOptions[0]?.label,
        value: partNoOptions[0]?.value,
      });
    }
  }, [partNoOptions]);

  const handleChangePlant = (selectedOption) => {
    setPlantSelected(selectedOption);
  };

  const [plantOptions, setPlantOptions] = useState([]);

  useEffect(() => {
    let tempPlantOptions = [];
    let data = plantReducer.plantData.data ? plantReducer.plantData.data : [];
    data.map((plant) => {
      tempPlantOptions.push({
        label: plant.plantCode,
        value: plant.plantCode,
      });
    });
    setPlantOptions(tempPlantOptions);
  }, [plantReducer]);

  useEffect(() => {
    if (plantOptions) {
      setPlantSelected({
        label: plantOptions[0]?.label,
        value: plantOptions[0]?.value,
      });
    }
  }, [plantOptions]);

  const [state, setState] = useState({
    columns: [
      { Header: "SR No", accessor: "id", align: "left" },
      { Header: "Part No", accessor: "itemCode", align: "left" },
      {
        Header: "Part Description",
        accessor: "itemDescription",
        align: "left",
      },
      { Header: "Created Date", accessor: "cd", align: "left" },
      { Header: "Delivery Month", accessor: "deliveryDate", align: "left" },
      { Header: "Balance QTY", accessor: "balanceQty", align: "left" },
      { Header: "Scheduled QTY", accessor: "scheduleQty", align: "left" },
      { Header: "Supply confirmation", accessor: "cnfQty", align: "left" },
      { Header: "Remark", accessor: "remark", align: "left" },
      {
        Header: "Action",
        accessor: "action",
        align: "center",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });

  const [stateForPlanner, setStateForPlanner] = useState({
    columns: [
      { Header: "SR No", accessor: "id", align: "left" },
      { Header: "Part No", accessor: "itemCode", align: "left" },
      {
        Header: "Part Description",
        accessor: "itemDescription",
        align: "left",
      },
      { Header: "Created Date", accessor: "cd", align: "left" },
      { Header: "Delivery Month", accessor: "deliveryDate", align: "left" },
      { Header: "Balance QTY", accessor: "balanceQty", align: "left" },
      { Header: "Scheduled QTY", accessor: "scheduleQty", align: "left" },
      { Header: "Supply confirmation", accessor: "cnfQty", align: "left" },
      { Header: "Remark", accessor: "remark", align: "left" },
      {
        Header: "Action",
        accessor: "action",
        align: "center",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });

  const { columns, rows } = roleName == "vendor" ? state : stateForPlanner;

  useEffect(() => {
    let tempMonthlyDemand = [];
    let data = monthlyDemandReducer.monthlyDemandData.data
      ? monthlyDemandReducer.monthlyDemandData.data
      : [];
    setLoading(monthlyDemandReducer.loading);
    setPaginationObj(monthlyDemandReducer?.monthlyDemandData?.pagination);
    data.map((singleMonthlyDemandData) => {
      let des = singleMonthlyDemandData?.itemDescription;
      let len = desLength;
      const formatDate = new Date(singleMonthlyDemandData.deliveryDate);
      const formatDateForCD = new Date(singleMonthlyDemandData.cd);

      const dataObject = {
        privateKey: singleMonthlyDemandData.monthlyDemandId,
        id: singleMonthlyDemandData.monthlyDemandId,
        partNoDes: `${singleMonthlyDemandData.itemCode} / ${
          des ? des.substring(0, len) : ""
        }`,
        cd: format(
          addMinutes(formatDateForCD, formatDateForCD.getTimezoneOffset()),
          "dd-MM-yyyy"
        ),
        itemCode: singleMonthlyDemandData.itemCode,
        partDescription: singleMonthlyDemandData.itemDescription,
        itemDescription: singleMonthlyDemandData.itemDescription,
        deliveryPlant: singleMonthlyDemandData.deliveryPlant,
        unloadingPoint: singleMonthlyDemandData.unloadingPoint,
        vendorCode: singleMonthlyDemandData.vendorCode,
        deliveryDate: singleMonthlyDemandData.deliveryMonth,
        scheduleQty: singleMonthlyDemandData.scheduleQty,
        balanceQty: singleMonthlyDemandData.balanceQty,
        demandDate: singleMonthlyDemandData.demandDate,
        deliveryMonth: singleMonthlyDemandData.deliveryMonth,
        purchaseOrderLineNumber: singleMonthlyDemandData.poLineNumber,
        purchaseOrderNumber: singleMonthlyDemandData.poNumber,
        uoe: singleMonthlyDemandData.uoe,
        plantCode: singleMonthlyDemandData.plantCode,
        remark:
          singleMonthlyDemandData.remark == (undefined || "undefined")
            ? "-"
            : singleMonthlyDemandData.remark,
        cnfQty: singleMonthlyDemandData.cnfQty,

        action:
          roleName == "vendor" ? (
            singleMonthlyDemandData.isUpdatable === 0 ? (
              <Tooltip title="Confirm">
                <MDButton
                  disabled
                  variant="gradient"
                  color="success"
                  iconOnly
                  type="button"
                  onClick={() =>
                    handleOpenUpdateCNFQTYModal(singleMonthlyDemandData)
                  }
                  style={{ marginRight: "5px" }}
                >
                  <Icon>edit_sharp</Icon>
                </MDButton>
              </Tooltip>
            ) : (
              <Tooltip title="Please Confirm CNF QTY">
                <MDButton
                  disabled={!updateCnfQtyAccess}
                  className="blink_me"
                  variant="gradient"
                  color="success"
                  iconOnly
                  type="button"
                  onClick={() =>
                    handleOpenUpdateCNFQTYModal(singleMonthlyDemandData)
                  }
                  style={{ marginRight: "5px" }}
                >
                  <Icon>edit_sharp</Icon>
                </MDButton>
              </Tooltip>
            )
          ) : enableUpdateCnfQtyAccess &&
            singleMonthlyDemandData.isUpdatable === 0 ? (
            <Tooltip title="Enable CNF Qty">
              <MDButton
                variant="gradient"
                color="success"
                type="button"
                onClick={() =>
                  handleOpenUpdateCnfQtyStatusByPlannerModal(
                    singleMonthlyDemandData
                  )
                }
              >
                Enable
              </MDButton>
            </Tooltip>
          ) : (
            <Tooltip title="Enable">
              <MDButton
                disabled
                variant="gradient"
                color="success"
                type="button"
                style={{ marginLeft: "0px" }}
              >
                Enable
              </MDButton>
            </Tooltip>
          ),
      };
      tempMonthlyDemand.push(dataObject);
    });
    viewAccess &&
      (roleName == "vendor"
        ? setState({ ...state, rows: tempMonthlyDemand })
        : setStateForPlanner({ ...stateForPlanner, rows: tempMonthlyDemand }));
  }, [monthlyDemandReducer]);

  const [download, setDownload] = useState("");
  useEffect(() => {
    let tempMonthlyDemand = [];
    let data = monthlyDemandDownloadReducer.monthlyDemandData.data
      ? monthlyDemandDownloadReducer.monthlyDemandData.data
      : [];
    console.log(data);
    data.map((singleMonthlyDemandData) => {
      let des = singleMonthlyDemandData?.itemDescription;
      let len = desLength;
      const formatDate = new Date(singleMonthlyDemandData.deliveryDate);
      const formatDateForCD = new Date(singleMonthlyDemandData.cd);

      const dataObject = {
        privateKey: singleMonthlyDemandData.monthlyDemandId,
        id: singleMonthlyDemandData.monthlyDemandId,
        partNoDes: `${singleMonthlyDemandData.itemCode} / ${
          des ? des.substring(0, len) : ""
        }`,
        // cd: format(
        //   addMinutes(formatDateForCD, formatDateForCD.getTimezoneOffset()),
        //   "dd-MM-yyyy"
        // ),
        createdDate: format(
          addMinutes(formatDateForCD, formatDateForCD.getTimezoneOffset()),
          "dd-MM-yyyy"
        ),
        itemCode: singleMonthlyDemandData.itemCode,
        partDescription: singleMonthlyDemandData.itemDescription,
        itemDescription: singleMonthlyDemandData.itemDescription,
        deliveryPlant: singleMonthlyDemandData.deliveryPlant,
        unloadingPoint: singleMonthlyDemandData.unloadingPoint,
        vendorCode: singleMonthlyDemandData.vendorCode,
        deliveryDate: singleMonthlyDemandData.deliveryMonth,
        scheduleQty: singleMonthlyDemandData.scheduleQty,
        balanceQty: singleMonthlyDemandData.balanceQty,
        demandDate: singleMonthlyDemandData.demandDate,
        deliveryMonth: singleMonthlyDemandData.deliveryMonth,
        purchaseOrderLineNumber: singleMonthlyDemandData.poLineNumber,
        purchaseOrderNumber: singleMonthlyDemandData.poNumber,
        uoe: singleMonthlyDemandData.uoe,
        plantCode: singleMonthlyDemandData.plantCode,
        remark:
          singleMonthlyDemandData.remark == (undefined || "undefined")
            ? "-"
            : singleMonthlyDemandData.remark,
        cnfQty: singleMonthlyDemandData.cnfQty,

        action:
          roleName == "vendor" ? (
            singleMonthlyDemandData.isUpdatable === 0 ? (
              <Tooltip title="Confirm">
                <MDButton
                  disabled
                  variant="gradient"
                  color="success"
                  iconOnly
                  type="button"
                  onClick={() =>
                    handleOpenUpdateCNFQTYModal(singleMonthlyDemandData)
                  }
                  style={{ marginRight: "5px" }}
                >
                  <Icon>edit_sharp</Icon>
                </MDButton>
              </Tooltip>
            ) : (
              <Tooltip title="Please Confirm CNF QTY">
                <MDButton
                  disabled={!updateCnfQtyAccess}
                  className="blink_me"
                  variant="gradient"
                  color="success"
                  iconOnly
                  type="button"
                  onClick={() =>
                    handleOpenUpdateCNFQTYModal(singleMonthlyDemandData)
                  }
                  style={{ marginRight: "5px" }}
                >
                  <Icon>edit_sharp</Icon>
                </MDButton>
              </Tooltip>
            )
          ) : enableUpdateCnfQtyAccess &&
            singleMonthlyDemandData.isUpdatable === 0 ? (
            <Tooltip title="Enable CNF Qty">
              <MDButton
                variant="gradient"
                color="success"
                type="button"
                onClick={() =>
                  handleOpenUpdateCnfQtyStatusByPlannerModal(
                    singleMonthlyDemandData
                  )
                }
              >
                Enable
              </MDButton>
            </Tooltip>
          ) : (
            <Tooltip title="Enable">
              <MDButton
                disabled
                variant="gradient"
                color="success"
                type="button"
                style={{ marginLeft: "0px" }}
              >
                Enable
              </MDButton>
            </Tooltip>
          ),
      };
      tempMonthlyDemand.push(dataObject);
    });

    setDownload(tempMonthlyDemand);
  }, [monthlyDemandDownloadReducer]);

  const [loading, setLoading] = useState(true);

  const [openUpdateCNFQTYModal, setOpenUpdateCNFQTYModal] = useState(false);
  const [
    singleMonthlyDemandDataForUpdate,
    setSingleMonthlyDemandDataForUpdate,
  ] = useState({});

  const handleOpenUpdateCNFQTYModal = (CNFQTY = {}) => {
    setSingleMonthlyDemandDataForUpdate(CNFQTY);
    setOpenUpdateCNFQTYModal(true);
    setIsErrorForUpdate(false);
    setIsSuccessForUpdate(false);
  };
  const handleCloseUpdateCNFQTYModal = () => {
    setOpenUpdateCNFQTYModal(false);

    formikForUpdate.setValues(initialValueForUpdate);
    formikForUpdate.setTouched({});
    formikForUpdate.setErrors({});
  };

  const [buttonName, setButtonName] = useState("Submit");
  const [errorMsgForUpdateQty, setErrorMsgForUpdateQty] = useState("");
  const [errorMsgForEnable, setErrorMsgForEnable] = useState("");
  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);

  useEffect(() => {
    if (isErrorForUpdate) {
      setTimeout(() => {
        setIsErrorForUpdate(false);
      }, 3000);
    }
  }, [isErrorForUpdate]);

  useEffect(() => {
    if (isSuccessForUpdate) {
      setTimeout(() => {
        setIsSuccessForUpdate(false);
      }, 3000);
    }
  }, [isSuccessForUpdate]);

  const initialValueForUpdate = {
    // departmentId: singleDepartmentDataForUpdate.departmentId,
    cnfQty: singleMonthlyDemandDataForUpdate.cnfQty,
    remark: singleMonthlyDemandDataForUpdate.remark,
  };

  const validationSchemaForUpdate = Yup.object({
    cnfQty: Yup.number()
      .min(1)
      .max(singleMonthlyDemandDataForUpdate.scheduleQty)
      .required("Enter a valid Qty"),
    // remark: Yup.string().required("Enter a valid remark"),
  });

  const onSubmitForUpdate = async (values) => {
    setButtonName("Please wait...");
    let payload = {
      vendorId: userId,
      vendorCode: singleMonthlyDemandDataForUpdate.vendorCode,
      itemCode: singleMonthlyDemandDataForUpdate.itemCode,
      demandId: singleMonthlyDemandDataForUpdate.monthlyDemandId,
      cnfQty: values.cnfQty,
      remark: values.remark,
    };

    let res = await updateCNFQty(payload, jwtToken);
    if (res.status) {
      setIsSuccessForUpdate(true);
      getMonthlyDemand(
        email,
        partNoSelected ? partNoSelected.value : "",
        plantSelected ? plantSelected.value : "",
        vendorsListForPlannerSelected
          ? vendorsListForPlannerSelected.value
          : "",
        roleName,
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken
      );
      setTimeout(() => {
        handleCloseUpdateCNFQTYModal();
        setButtonName("Submit");
      }, 2250);
    }
    if (!res.status) {
      setIsErrorForUpdate(true);
      setErrorMsgForUpdateQty(
        res.data.data.message ? res.data.data.message : res?.data?.data?.msg
      );
      setButtonName("Submit");
    }
  };

  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    onSubmit: onSubmitForUpdate,
    validationSchema: validationSchemaForUpdate,
    enableReinitialize: true,
  });

  const [openUpdateRemarkModal, setOpenUpdateRemarkModal] = useState(false);

  const handleOpenUpdateRemarkModal = (remark = {}) => {
    setSingleMonthlyDemandDataForUpdate(remark);
    setOpenUpdateRemarkModal(true);
    setIsErrorForUpdateRemark(false);
    setIsSuccessForUpdateRemark(false);
  };
  const handleCloseUpdateRemarkModal = () => {
    setOpenUpdateRemarkModal(false);
    formikForUpdateRemark.setErrors({});
  };

  const [isErrorForUpdateRemark, setIsErrorForUpdateRemark] = useState(false);
  const [isSuccessForUpdateRemark, setIsSuccessForUpdateRemark] =
    useState(false);

  useEffect(() => {
    if (isErrorForUpdateRemark) {
      setTimeout(() => {
        setIsErrorForUpdateRemark(false);
      }, 3000);
    }
  }, [isErrorForUpdateRemark]);

  useEffect(() => {
    if (isSuccessForUpdateRemark) {
      setTimeout(() => {
        setIsSuccessForUpdateRemark(false);
      }, 3000);
    }
  }, [isSuccessForUpdateRemark]);

  const initialValueForUpdateRemark = {
    remark: singleMonthlyDemandDataForUpdate.remark,
  };

  const validationSchemaForUpdateRemark = Yup.object({
    remark: Yup.string().required("Enter a remark!"),
  });

  const onSubmitForUpdateRemark = async (values) => {
    let payload = {
      vendorId: userId,
      vendorCode: singleMonthlyDemandDataForUpdate.vendorCode,
      partCode: singleMonthlyDemandDataForUpdate.itemCode,
      demandId: singleMonthlyDemandDataForUpdate.id,
      remark: values.remark,
    };

    let res = await updateRemark(payload, jwtToken);
    if (res.status) {
      setIsSuccessForUpdateRemark(true);
      getMonthlyDemand(
        email,
        partNoSelected ? partNoSelected.value : "",
        plantSelected ? plantSelected.value : "",
        vendorsListForPlannerSelected
          ? vendorsListForPlannerSelected.value
          : "",
        roleName,
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken
      );
    }
    if (!res.status) {
      setIsErrorForUpdateRemark(true);
    }
  };

  const formikForUpdateRemark = useFormik({
    initialValues: initialValueForUpdateRemark,
    onSubmit: onSubmitForUpdateRemark,
    validationSchema: validationSchemaForUpdateRemark,
    enableReinitialize: true,
  });

  const DataUploadSuccessNotification = () =>
    toast.success("Data Uploaded Successfully", {
      position: "top-center",
      autoClose: 2000,
    });

  const DataUploadFailureNotification = (data) =>
    toast.error(data, {
      position: "top-center",
      autoClose: 2000,
    });

  const [uploadCsvFilter, setUploadCsvFilter] = useState(false);

  const uploadCsvFilterHandler = () => {
    setUploadCsvFilter(!uploadCsvFilter);
  };

  const [uploadCsvData, setUploadCsvData] = useState({});

  const uploadCsvHandler = async () => {
    setUploadLoader(true);

    let data = new FormData();

    data.append("file", uploadCsvData);

    let res = await uploadCsvForMonthlyDemand(data, jwtToken);

    if (res.status) {
      setUploadLoader(false);

      getMonthlyDemand(
        email,
        partNoSelected ? partNoSelected.value : "",
        plantSelected ? plantSelected.value : "",
        vendorsListForPlannerSelected
          ? vendorsListForPlannerSelected.value
          : "",
        roleName,
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken
      );
      setUploadCsvFilter(false);
      DataUploadSuccessNotification();
    }
    if (!res.status) {
      setUploadLoader(false);
      DataUploadFailureNotification(res?.data?.data?.msg);
    }
  };

  const [
    openUpdateCnfQtyStatusByPlannerModal,
    setOpenUpdateCnfQtyStatusByPlannerModal,
  ] = useState(false);

  const handleOpenUpdateCnfQtyStatusByPlannerModal = (CNFQTY = {}) => {
    setSingleMonthlyDemandDataForUpdate(CNFQTY);
    setOpenUpdateCnfQtyStatusByPlannerModal(true);
    setIsErrorForUpdateCnfQtyStatusByPlanner(false);
    setIsSuccessForUpdateCnfQtyStatusByPlanner(false);
  };
  const handleCloseUpdateCnfQtyStatusByPlannerModal = () => {
    setOpenUpdateCnfQtyStatusByPlannerModal(false);
  };

  const [
    isErrorForUpdateCnfQtyStatusByPlanner,
    setIsErrorForUpdateCnfQtyStatusByPlanner,
  ] = useState(false);
  const [
    isSuccessForUpdateCnfQtyStatusByPlanner,
    setIsSuccessForUpdateCnfQtyStatusByPlanner,
  ] = useState(false);

  useEffect(() => {
    if (isErrorForUpdateCnfQtyStatusByPlanner) {
      setTimeout(() => {
        setIsErrorForUpdateCnfQtyStatusByPlanner(false);
      }, 3000);
    }
  }, [isErrorForUpdateCnfQtyStatusByPlanner]);

  useEffect(() => {
    if (isSuccessForUpdateCnfQtyStatusByPlanner) {
      setTimeout(() => {
        setIsSuccessForUpdateCnfQtyStatusByPlanner(false);
      }, 3000);
    }
  }, [isSuccessForUpdateCnfQtyStatusByPlanner]);

  const handleUpdateCnfQtyStatusByPlanner = async () => {
    let id = singleMonthlyDemandDataForUpdate?.monthlyDemandId;
    let response = await updateCnfQtyStatusByPlanner(id, jwtToken);
    if (response.status) {
      getMonthlyDemand(
        email,
        partNoSelected ? partNoSelected.value : "",
        plantSelected ? plantSelected.value : "",
        vendorsListForPlannerSelected
          ? vendorsListForPlannerSelected.value
          : "",
        roleName,
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken
      );
      setIsSuccessForUpdateCnfQtyStatusByPlanner(true);
      setTimeout(() => {
        handleCloseUpdateCnfQtyStatusByPlannerModal();
      }, 2250);
    }
    if (!response.status) {
      setErrorMsgForEnable(response?.data?.data?.msg);
      setIsErrorForUpdateCnfQtyStatusByPlanner(true);
    }
  };

  const headers = [
    {
      label: "itemCode",
      key: "itemCode",
    },
    {
      label: "itemDescription",
      key: "itemDescription",
    },

    {
      label: "vendorCode",
      key: "vendorCode",
    },
    {
      label: "vendorName",
      key: "vendorName",
    },
    {
      label: "plantCode",
      key: "plantCode",
    },
    {
      label: "demandDate",
      key: "demandDate",
    },
    {
      label: "deliveryMonth",
      key: "deliveryMonth",
    },
    {
      label: "scheduleQty",
      key: "scheduleQty",
    },
    {
      label: "balanceQty",
      key: "balanceQty",
    },
    {
      label: "cnfQty",
      key: "cnfQty",
    },

    {
      label: "poNumber",
      key: "poNumber",
    },
    {
      label: "poLineNumber",
      key: "poLineNumber",
    },

    {
      label: "remark",
      key: "remark",
    },

    {
      label: "uoe",
      key: "uoe",
    },
  ];

  const headers2 = [
    {
      label: "itemCode",
      key: "itemCode",
    },
    {
      label: "itemDescription",
      key: "itemDescription",
    },

    {
      label: "vendorCode",
      key: "vendorCode",
    },

    {
      label: "plantCode",
      key: "plantCode",
    },
    {
      label: "demandDate",
      key: "demandDate",
    },
    {
      label: "deliveryMonth",
      key: "deliveryMonth",
    },
    {
      label: "scheduleQty",
      key: "scheduleQty",
    },
    {
      label: "balanceQty",
      key: "balanceQty",
    },
    {
      label: "cnfQty",
      key: "cnfQty",
    },

    {
      label: "purchaseOrderNumber",
      key: "purchaseOrderNumber",
    },
    {
      label: "purchaseOrderLineNumber",
      key: "purchaseOrderLineNumber",
    },

    {
      label: "remark",
      key: "remark",
    },

    {
      label: "uoe",
      key: "uoe",
    },
    {
      label: "createdDate",
      key: "createdDate",
    },
  ];

  const csvLink = {
    filename: "Monthly Demand.csv",
    headers: headers,
    data: [],
  };

  const csvLink2 = {
    filename: "List Of Monthly Demands.csv",
    headers: headers2,
    data: download,
  };

  
      
              
                const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
                useEffect(() => {
                  getDynamicColumn(userId, subModuleId, jwtToken);
                }, [userId, subModuleId]);
              
                const [dynamicColumnData, setDynamicColumnData] = useState("");
              
                let hiddenColumsDetails = cookies.get("hidden-column-data");
                useEffect(() => {
                  let data = getDynamicColumnReducer.dynamicColumn.data
                    ? getDynamicColumnReducer.dynamicColumn.data
                    : [];
              
                  setDynamicColumnData(data);
                  cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
                    path: "/",
                  });
              
                  setTimeout(() => {
                    setLoadingForDynamicColumn(true);
                  }, 1000);
                }, [getDynamicColumnReducer, loading]);
              
                const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
                  useState(false);
              
                const handleOpenCreateColumnReorderModal = () => {
                  setOpenCreateColumnReorderModal(true);
                };
              
                const handleCloseCreateColumnReorderModal = () => {
                  setOpenCreateColumnReorderModal(false);
                };
              
                const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
                const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);
              
                useEffect(() => {
                  if (isErrorColumnReorder) {
                    setTimeout(() => {
                      setIsErrorColumnReorder(false);
                    }, 3000);
                  }
                }, [isErrorColumnReorder]);
              
                useEffect(() => {
                  if (isSuccessColumnReorder) {
                    setTimeout(() => {
                      setIsSuccessColumnReorder(false);
                    }, 3000);
                  }
                }, [isSuccessColumnReorder]);
              
                const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
                  useState(false);
              
                const handleDynamicColumn = async () => {
                  let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
                  if (res.status) {
                    setIsSuccessColumnReorder(true);
                    getDynamicColumn(userId, subModuleId, jwtToken); 
                         getMonthlyDemand(
        email,
        partNoSelected ? partNoSelected.value : "",
        plantSelected ? plantSelected.value : "",
        vendorsListForPlannerSelected
          ? vendorsListForPlannerSelected.value
          : "",
        roleName,
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken
      );
                    setTimeout(() => {
                      handleCloseCreateColumnReorderModal();
                      // window.location.reload();
                    }, 2250);
                  }
                  if (!res.status) {
                    setIsErrorColumnReorder(true);
                    setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
                  }
                };
              
  

  return (
    <MDBox pt={0} pb={3}>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Card>
            <MDBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={3}
              mb={-5}
              mt={-4}
            >
              <Grid container spacing={2}>
                <Grid item xs={8}>
                  <MDBox>
                    <MDBox
                      display="flex"
                      mt={2}
                      flexDirection={{ xs: "column", lg: "row" }}
                    >
                      {roleName !== "vendor" && (
                        <MDBox
                          width={{ xs: "250px", lg: "800px" }}
                          style={{
                            // width: { xs: "400px", lg: "800px" },
                            marginRight: "10px",
                          }}
                        >
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: 500 }}
                          >
                            Vendors
                          </MDTypography>
                          <Select
                            isClearable
                            placeholder="Vendors"
                            className="select-css-for-filter"
                            value={vendorsListForPlannerSelected}
                            options={vendorsListForPlannerOptions}
                            onChange={handleChangeVendorsListForPlanner}
                            autoComplete="off"
                          />
                        </MDBox>
                      )}
                      <MDBox
                        width={{ xs: "250px", lg: "350px" }}
                        style={{
                          // width: { xs: "400px", lg: "800px" },
                          marginRight: "10px",
                        }}
                      >
                        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                          Part Code
                        </MDTypography>

                        {roleName !== "vendor" ? (
                          <Select
                            isClearable
                            placeholder="Part No"
                            className="select-css-for-filter"
                            value={partNoSelected}
                            options={
                              vendorsListForPlannerSelected
                                ? partNoOptions
                                : partNoForPlannerOptions
                            }
                            onChange={handleChangePartNo}
                            autoComplete="off"
                          />
                        ) : (
                          <Select
                            isClearable
                            placeholder="Part No"
                            className="select-css-for-filter"
                            value={partNoSelected}
                            options={partNoOptions}
                            onChange={handleChangePartNo}
                            autoComplete="off"
                          />
                        )}
                      </MDBox>
                      <MDBox width="250px" style={{ marginRight: "10px" }}>
                        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                          Plant
                        </MDTypography>
                        <Select
                          isDisabled={true}
                          placeholder="Plant"
                          className="select-css-for-filter"
                          value={plantSelected}
                          options={plantOptions}
                          onChange={handleChangePlant}
                          autoComplete="off"
                        />
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </Grid>

                <Grid item xs={8} lg={4}>
                  {/* {roleName !== "Vendor" && ( */}
                  <MDBox
                    color="text"
                    px={2}
                    display="flex"
                    flexDirection="column"
                  >
                    <MDBox
                      display="flex"
                      marginLeft={0}
                      marginTop="6px"
                      marginBottom="5px"
                    >
                      {uploadAccess && (
                        <CSVLink {...csvLink}>
                          <Tooltip>
                            <DownloadButton
                              tooltip="Download Template"
                              style={{ marginRight: "0.5rem" }}
                              type="button"
                              variant="outlined"
                              color="error"
                              iconOnly
                              title="Download Template"
                            >
                              <Icon>download</Icon>
                            </DownloadButton>
                          </Tooltip>
                        </CSVLink>
                      )}

                      {uploadAccess && (
                        <Tooltip>
                          <UploadButton
                            tooltip="Upload CSV"
                            type="button"
                            variant="outlined"
                            color="info"
                            iconOnly
                            onClick={uploadCsvFilterHandler}
                            title="Upload CSV"
                          >
                            <Icon>upload</Icon>
                          </UploadButton>
                        </Tooltip>
                      )}

                      {downloadAccess && (
                        <CSVLink {...csvLink2}>
                          <Tooltip>
                            <DownloadDataButton
                              tooltip="Download All Data"
                              style={{ marginLeft: "0.5rem" }}
                              type="button"
                              variant="outlined"
                              color="success"
                              iconOnly
                              title="Download All Data"
                            >
                              <Icon>download</Icon>
                            </DownloadDataButton>
                          </Tooltip>
                        </CSVLink>
                      )}
                    </MDBox>
                    <MDBox mr={2}>
                      {uploadCsvFilter && (
                        <div>
                          <div>
                            <input
                              className="choose_file"
                              type="file"
                              accept=".csv"
                              onChange={(e) => {
                                setUploadCsvData(e.target.files[0]);
                              }}
                            />
                            <MDButton
                              disabled={
                                !uploadCsvData?.name ||
                                uploadCsvData?.type !== "text/csv"
                              }
                              variant="contained"
                              color="info"
                              style={{
                                marginLeft: "0",
                                marginTop: "0.3rem",
                                padding: 1,
                                height: "10px",
                              }}
                              type="button"
                              onClick={uploadCsvHandler}
                            >
                              Upload
                            </MDButton>
                          </div>
                          <div>
                            <span
                              style={{
                                color: "red",
                                fontSize: "14px",
                                marginLeft: "0px",
                                fontStyle: "italic",
                              }}
                            >
                              <strong>*</strong> Please upload
                              <strong>".csv"</strong> file only
                            </span>
                          </div>
                        </div>
                      )}
                    </MDBox>
                  </MDBox>
                  {/* )} */}
                </Grid>
              </Grid>
            </MDBox>
            <MDBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={3}
              mb={-6}
            >
              <MDBox>
                <MDBox
                  flexDirection={{
                    xs: "column",
                    sm: "column",
                    md: "row",
                    lg: "row",
                    xl: "row",
                  }}
                  style={{ display: "flex" }}
                  mb={2}
                  ml={0}
                ></MDBox>
              </MDBox>
            </MDBox>

            <MDBox pt={1}>
            <DataTable
                                       table={{ columns, rows }}
                                   isSorted
                                   tableSearch
                                   showTotalEntries
                                   noEndBorder
                                   loading={loading}
                                 
                                   entriesPerPage={{
                                     defaultValue: 5,
                                     entries: [5, 10, 15, 20, 25, 30],
                                   }}                                        
                                   serverSidePagination
                                   paginationObj={paginationObj}
                                   pageNoValue={pageNo}
                                   rowsPerPageValue={rowsPerPage}
                                   pageNoProp={importPageNo}
                                   rowsPerPageProp={importRowsPerPage}
                                   searchProp={importSearch}        
                                   visibleColumns2={dynamicColumnData?.visibleFields}
                                   dynamicColumnData={dynamicColumnData}
                                 
                                   /* Table options */
                                   options={{ draggable: false }}
                                 
                                   /* Column reorder */
                                   handleOpenCreateColumnReorderModal={
                                     handleOpenCreateColumnReorderModal
                                   }
                                 
                                   /* Meta */
                                   subModuleId={subModuleId}
                                   userId={userId}
                                    />
            </MDBox>

            
                                                   <Modal
                                                                                            open={openCreateColumnReorderModal}
                                                                                            onClose={handleCloseCreateColumnReorderModal}
                                                                                            aria-labelledby="modal-modal-title"
                                                                                            aria-describedby="modal-modal-description"
                                                                                            style={{ backdropFilter: "blur(5px)" }}
                                                                                          >
                                                                                            <MDCard sx={styleForColumnReorder}>
                                                                                              <MDTypography>Are you sure you want to submit?</MDTypography>
                                                                                              <MDBox mt={2}>
                                                                                                <MDButton
                                                                                                  style={{ width: "10rem", marginRight: "0.5rem" }}
                                                                                                  color="info"
                                                                                                  variant="outlined"
                                                                                                  onClick={handleCloseCreateColumnReorderModal}
                                                                                                >
                                                                                                  Cancel
                                                                                                </MDButton>
                                                                                                <MDButton
                                                                                                  style={{ width: "10rem", marginLeft: "0.5rem" }}
                                                                                                  color="success"
                                                                                                  onClick={handleDynamicColumn}
                                                                                                  // disabled={denyButtonName === "Please wait..."}
                                                                                                >
                                                                                                  Submit
                                                                                                </MDButton>
                                                                                              </MDBox>
                                                                                              <MDBox mt={2}>
                                                                                                <Collapse in={isSuccessColumnReorder}>
                                                                                                  <Alert
                                                                                                    severity="success"
                                                                                                    action={
                                                                                                      <IconButton
                                                                                                        aria-label="close"
                                                                                                        color="inherit"
                                                                                                        size="small"
                                                                                                        onClick={() => {
                                                                                                          setIsSuccessColumnReorder(false);
                                                                                                        }}
                                                                                                      >
                                                                                                        <CloseIcon fontSize="inherit" />
                                                                                                      </IconButton>
                                                                                                    }
                                                                                                  >
                                                                                                    Data updated successfully!
                                                                                                  </Alert>
                                                                                                </Collapse>
                                                                                                <Collapse in={isErrorColumnReorder}>
                                                                                                  <Alert
                                                                                                    severity="error"
                                                                                                    action={
                                                                                                      <IconButton
                                                                                                        aria-label="close"
                                                                                                        color="inherit"
                                                                                                        size="small"
                                                                                                        onClick={() => {
                                                                                                          setIsErrorColumnReorder(false);
                                                                                                        }}
                                                                                                      >
                                                                                                        <CloseIcon fontSize="inherit" />
                                                                                                      </IconButton>
                                                                                                    }
                                                                                                  >
                                                                                                    {isErrorMsgForColumnReorder}
                                                                                                  </Alert>
                                                                                                </Collapse>
                                                                                              </MDBox>
                                                                                            </MDCard>
                                                                                          </Modal>

            <Modal
              open={openUpdateCNFQTYModal}
              onClose={handleCloseUpdateCNFQTYModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={style}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                    Confirm CNF QTY An Give Remark
                  </MDTypography>
                  <MDBox>
                    <Tooltip title="Close">
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        onClick={handleCloseUpdateCNFQTYModal}
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          marginLeft: "-55px",
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formikForUpdate.handleSubmit}
                  >
                    <MDBox mb={2}>
                      <MDTypography variant="h6">CNF QTY</MDTypography>
                      <MDInput
                        type="number"
                        name="cnfQty"
                        fullWidth
                        autoComplete="off"
                        inputProps={{
                          maxLength: 45,
                        }}
                        onBlur={formikForUpdate.handleBlur}
                        onChange={formikForUpdate.handleChange}
                        value={formikForUpdate.values.cnfQty}
                        error={
                          formikForUpdate.touched.cnfQty &&
                          formikForUpdate.errors.cnfQty &&
                          true
                        }
                      />
                      {formikForUpdate.touched.cnfQty &&
                        formikForUpdate.errors.cnfQty && (
                          <TextError msg={formikForUpdate.errors.cnfQty} />
                        )}
                    </MDBox>

                    <MDBox mb={2}>
                      <MDTypography variant="h6">Remark</MDTypography>
                      <MDInput
                        type="text"
                        name="remark"
                        fullWidth
                        autoComplete="off"
                        onBlur={formikForUpdate.handleBlur}
                        onChange={formikForUpdate.handleChange}
                        value={formikForUpdate.values.remark}
                        error={
                          formikForUpdate.touched.remark &&
                          formikForUpdate.errors.remark &&
                          true
                        }
                        inputProps={{
                          maxLength: 45,
                        }}
                      />
                      {formikForUpdate.touched.remark &&
                        formikForUpdate.errors.remark && (
                          <TextError msg={formikForUpdate.errors.remark} />
                        )}
                    </MDBox>

                    <MDBox>
                      <Collapse in={isErrorForUpdate}>
                        <Alert
                          severity="error"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsErrorForUpdate(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          {errorMsgForUpdateQty}
                        </Alert>
                      </Collapse>
                      <Collapse in={isSuccessForUpdate}>
                        <Alert
                          severity="success"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsErrorForUpdate(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          CNF Qty and remark updated successfully
                        </Alert>
                      </Collapse>
                    </MDBox>
                    <MDBox mt={3}>
                      <MDButton
                        variant="contained"
                        color="success"
                        fullWidth
                        type="submit"
                        disabled={
                          !formikForUpdate.isValid ||
                          buttonName === "Please wait..."
                        }
                      >
                        {buttonName}
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={openUpdateCnfQtyStatusByPlannerModal}
              onClose={handleCloseUpdateCnfQtyStatusByPlannerModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={enableStyle}>
                <MDTypography>Are you sure you want to enable?</MDTypography>
                <MDBox mt={2} display="flex">
                  <div>
                    <MDButton
                      style={{ width: "100%", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseUpdateCnfQtyStatusByPlannerModal}
                    >
                      Cancel
                    </MDButton>
                  </div>
                  <div style={{ float: "right" }}>
                    <MDButton
                      style={{ width: "100%", marginLeft: "0.5rem" }}
                      color="success"
                      onClick={handleUpdateCnfQtyStatusByPlanner}
                    >
                      Enable
                    </MDButton>
                  </div>
                </MDBox>
                <MDBox mt={2}>
                  <Collapse in={isErrorForUpdateCnfQtyStatusByPlanner}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorForUpdateCnfQtyStatusByPlanner(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {errorMsgForEnable}
                    </Alert>
                  </Collapse>
                  <Collapse in={isSuccessForUpdateCnfQtyStatusByPlanner}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorForUpdateCnfQtyStatusByPlanner(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Enabled successfully
                    </Alert>
                  </Collapse>
                </MDBox>
              </MDCard>
            </Modal>
          </Card>
        </Grid>
      </Grid>

      {(uploadLoader || loading) && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
    </MDBox>
  );
};

const mapStateToProps = (state) => {
  return {
    monthlyDemandReducer: state.monthlyDemandReducer,
    partNoForPlannerReducer: state.partNoForPlannerReducer,

    monthlyDemandDownloadReducer: state.monthlyDemandDownloadReducer,
    partNoReducer: state.partNoReducer,
    plantReducer: state.plantReducer,
    vendorsListForPlannerReducer: state.vendorsListForPlannerReducer,
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    
    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getMonthlyDemand: (
      userId,
      partNo,
      plant,
      vendorCode,
      roleName,
      pageNo,
      rowsPerPage,
      searchObject,
      jwtToken
    ) =>
      dispatch(
        getMonthlyDemand(
          userId,
          partNo,
          plant,
          vendorCode,
          roleName,
          pageNo,
          rowsPerPage,
          searchObject,
          jwtToken
        )
      ),
    getMonthlyDemandDownload: (
      userId,
      partNo,
      plant,
      vendorCode,
      roleName,
      pageNo,
      rowsPerPage,
      searchObject,
      jwtToken
    ) =>
      dispatch(
        getMonthlyDemandDownload(
          userId,
          partNo,
          plant,
          vendorCode,
          roleName,
          pageNo,
          rowsPerPage,
          searchObject,
          jwtToken
        )
      ),
    getPartNoForPlanner: (jwtToken) => dispatch(getPartNoForPlanner(jwtToken)),
    getPartNo: (userId, jwtToken) => dispatch(getPartNo(userId, jwtToken)),
    getPlant: (jwtToken) => dispatch(getPlant(jwtToken)),
    getVendorsListForPlanner: (jwtToken) =>
      dispatch(getVendorsListForPlanner(jwtToken)),
    updateCNFQty: (payload, jwtToken) =>
      dispatch(updateCNFQty(payload, jwtToken)),
    updateCnfQtyStatusByPlanner: (id, jwtToken) =>
      dispatch(updateCnfQtyStatusByPlanner(id, jwtToken)),
    updateRemark: (payload, jwtToken) =>
      dispatch(updateRemark(payload, jwtToken)),
    uploadCsvForMonthlyDemand: (payload, jwtToken) =>
      dispatch(uploadCsvForMonthlyDemand(payload, jwtToken)),
        getDynamicColumn: (userId, subModuleId, jwtToken) =>
                      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
                    createDynamicColumn: (payload, jwtToken) =>
                      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(MonthlyDemand);
